export default __webpack_public_path__ + "static/media/DunbarText-Regular.87f9d1b3.woff2";